import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CFormSelect,
  CSpinner,
} from "@coreui/react";

import "../../Table/Table.scss";

const EquipmentTab = ({ object, activeTab }) => {
  const [equipmentData, setEquipmentData] = useState([]);
  const [equipmentType, setEquipmentType] = useState("0");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    // Грузим данные только если это вкладка "Оборудование"
    if (object?.LDoc && activeTab === 1) {
      const filterValue = equipmentType;
      setLoading(true);
      setErrorMessage(""); // Сбрасываем сообщение об ошибке

      axios
        .get(
          `/api/ldoc/${object.LDoc}/equipment/?filter_type=${parseInt(
            filterValue
          )}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((response) => {
          // Проверяем, есть ли данные
          if (response.data.message) {
            setErrorMessage(response.data.message); // Устанавливаем сообщение об ошибке
            setEquipmentData([]); // Очищаем данные
          } else {
            setEquipmentData(response.data || []);
          }
        })
        .catch((error) => {
          if (error.response) {
          } else if (error.request) {
          } else {
          }
        })
        .finally(() => setLoading(false));
    } else {
      setEquipmentData([]);
    }
  }, [object?.LDoc, activeTab, equipmentType]);

  const handleTypeChange = (e) => {
    const selectedType = e.target.value;
    setEquipmentType(selectedType); // Обновляем выбранный тип
  };

  return (
    <div style={{ overflow: "scroll" }}>
      <CFormSelect
        value={equipmentType}
        onChange={handleTypeChange}
        className="mb-3"
      >
        <option value="0">Существующее</option>
        <option value="1">Демонтируемое</option>
        <option value="2">Проектируемое</option>
        <option value="3">Перспективное</option>
      </CFormSelect>

      {loading ? (
        <CSpinner color="primary" />
      ) : errorMessage ? (
        <p>{errorMessage}</p> // Выводим сообщение об ошибке
      ) : equipmentData.length > 0 ? (
        <CTable className="about-objects__table">
          <CTableHead className="about-objects__head">
            <CTableRow>
              <CTableHeaderCell>Оборудование</CTableHeaderCell>
              <CTableHeaderCell>Количество</CTableHeaderCell>
              <CTableHeaderCell>Отметка подвеса м.</CTableHeaderCell>
              <CTableHeaderCell>Габаритные размеры м.</CTableHeaderCell>
              <CTableHeaderCell>Масса кг.</CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody className="about-objects__body">
            {equipmentData.map((item, index) => (
              <CTableRow key={index}>
                <CTableDataCell>{item.NameEquipment || "N/A"}</CTableDataCell>
                <CTableDataCell>
                  {item.QuantityEquipment || "N/A"}
                </CTableDataCell>
                <CTableDataCell>{item.MarkEquipment || "N/A"}</CTableDataCell>
                <CTableDataCell>{item.SizeEquipment || "N/A"}</CTableDataCell>
                <CTableDataCell>{item.WeightEquipment || "N/A"}</CTableDataCell>
              </CTableRow>
            ))}
          </CTableBody>
        </CTable>
      ) : (
        <p>Оборудование не найдено для выбранного типа.</p>
      )}
    </div>
  );
};

export default EquipmentTab;
